import React, { useState, useEffect } from "react";
import Modal from 'react-modal';


const DrugDetailsModal = ({ show, onClose, onNext, drugName, homeQty, numRefills, setDrugName, drugNames, setHomeQty, setNumRefills, treatment }) => {
  // debugger
  console.log("DrugDetailsModal drugNames:", drugNames);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredDrugs, setFilteredDrugs] = useState([]);
  const [isDrugSelected, setIsDrugSelected] = useState(false);

  useEffect(() => {
    if (show) {
      setDrugName("");
      setHomeQty("");
      setNumRefills("");
      setIsDrugSelected(false);
      setFilteredDrugs([]);
      setShowDropdown(false);
    }
  }, [show, setDrugName, setHomeQty, setNumRefills]);

  if (!show) return null;

  const handleDrugNameChange = (e) => {
    // debugger
    const value = e.target.value;
    setDrugName(value);
    setIsDrugSelected(false);
    if (value.length >= 3) {
      // DrugNames is array of objects: { Name, NDC }
      const matches = Array.isArray(drugNames)
        ? drugNames.filter(d => d.Name && d.Name.toLowerCase().includes(value.toLowerCase())).map(d => d.Name)
        : [];
      setFilteredDrugs(matches);
      setShowDropdown(matches.length > 0);
    } else {
      setShowDropdown(false);
      setFilteredDrugs([]);
    }
  };

  const handleDrugSelect = (drug) => {
    setDrugName(drug);
    setIsDrugSelected(true);
    setShowDropdown(false);
  };

  // Validation function for all fields
  const getFieldErrors = () => {
    const errors = {};
    if (!drugName || drugName.trim().length < 3) {
      errors.drugName = "Please enter at least 3 characters to search the drug.";
    } else if (!isDrugSelected) {
      errors.drugName = "Please select a drug name from the dropdown.";
    }
    if (homeQty === "" || isNaN(homeQty) || Number(homeQty) <= 0 || !Number.isInteger(Number(homeQty))) {
      errors.homeQty = "Please enter a valid Home Qty (must be a positive whole number).";
    }
    if (numRefills === "" || isNaN(numRefills) || Number(numRefills) < 0 || !Number.isInteger(Number(numRefills))) {
      errors.numRefills = "Please enter a valid Number of Refills (0 or more, whole number).";
    }
    return errors;
  };
  const fieldErrors = getFieldErrors();

  // Next button handler with validation
  const handleNext = () => {
    const errors = getFieldErrors();
    if (!drugName || !homeQty || !numRefills || Object.keys(errors).length > 0) {
      return;
    }
    onNext({ drugName, homeQty, numRefills });
  };

  return (
  <Modal
    isOpen={show}
    onRequestClose={onClose}
    className="tracker-modal-content-dr"
    overlayClassName="tracker-modal-overlay"
    shouldCloseOnOverlayClick={false}
  >
    <div className="model-form-wrapper">
      <h2 className="text-center">Drug details</h2>

      <div className="mb-4 row align-items-center">
        <label className="col-sm-4 model-form-label">Treatment</label>
        <div className="col-sm-6">{treatment || ""}</div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleNext();
        }}
      >
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">Drug Name</label>
          <div className="col-sm-6 position-relative">
            <input
              type="text"
              className="form-control win-form-control mobile-view"
              placeholder="Drug Name"
              value={drugName}
              onChange={handleDrugNameChange}
              autoComplete="off"
              required
            />
            <div className="form-text">
              {drugName.length < 3
                ? "Please enter at least 3 characters to search the drug"
                : filteredDrugs.length === 0
                ? "No matching drugs found"
                : !isDrugSelected
                ? "Please choose a drug from the dropdown"
                : ""}
            </div>
            {showDropdown &&
              drugName.length >= 3 &&
              filteredDrugs.length > 0 && (
                <ul className="dropdown-menu show">
                  {filteredDrugs.map((drug, idx) => (
                    <li
                      key={idx}
                      className="dropdown-item"
                      onMouseDown={() => handleDrugSelect(drug)}
                    >
                      {drug}
                    </li>
                  ))}
                </ul>
              )}
            {fieldErrors.drugName && (
              <span className="form-field-error-message">
                {fieldErrors.drugName}
              </span>
            )}
          </div>
        </div>

        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">Home Qty</label>
          <div className="col-sm-6">
            <input
              type="number"
              min="0"
              max="999"
              className="form-control win-form-control mobile-view"
              placeholder="Home Qty"
              value={homeQty}
              onChange={(e) => setHomeQty(e.target.value)}
              required
            />
            {fieldErrors.homeQty && (
              <span className="form-field-error-message">
                {fieldErrors.homeQty}
              </span>
            )}
          </div>
        </div>

        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">Number of Refills</label>
          <div className="col-sm-6">
            <input
              type="number"
              min="0"
              max="999"
              className="form-control win-form-control mobile-view"
              placeholder="Number of Refills"
              value={numRefills}
              onChange={(e) => setNumRefills(e.target.value)}
              required
            />
            {fieldErrors.numRefills && (
              <span className="form-field-error-message">
                {fieldErrors.numRefills}
              </span>
            )}
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-sm-8 offset-sm-4">
            <button
              type="button"
              className="win-btn-secondary model-popup-btn me-3 mb-3 mb-md-0"
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="submit"
              className="win-btn-primary model-popup-btn"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </div>
  </Modal>
);

};

export default DrugDetailsModal;
